<template>
  <div class="wrapper">
    <a-table :loading="loading" :rowSelection="rowSelection" :bordered='true' :rowKey="rowKey" :pagination="pagination" :locale="locale" :columns="columns" :dataSource="data">
      <template slot='name' slot-scope="text,record,index">
          <a href="javascript:;" @click='()=>enterpriseName(record)'>{{text}}</a>
      </template>
      <template slot='work_name' slot-scope="text,record,index">
          <a href="javascript:;" @click='()=>producePollution(record)'>{{text}}</a>
      </template>
      <template slot='update_date' slot-scope="text,record,index">
          {{text|formatterTime}}
      </template>
      <template slot='create_time' slot-scope="text,record,index">
          {{text|formatterTime}}
      </template>
    </a-table>
  </div>
</template>

<script>
import tableData from '../tableData.json';
import moment from 'moment';
import _ from 'underscore';
export default {
  components: {
  },
  props: {
    columns: Array,
    rowSelection:{
      type:Object,
      default:()=>{},
    },
    queryUrl: String,
    rowKey: {
      type: String,
      required: true,
    },
    locale:{
      type:Object,
      default:()=>{emptyText:'无异常'},
    },
    params:Object,
    bottomText:String,
    isUpperPage:{
      type:Boolean,
      default:false,
    }
  },
  data() {
    return {
      visible: false,
      editingRecord: {},
      data: [],
      loading: false,
      pagination: {
        // 分页配置器开始
        pageSize: 10,
        current: 1,
        total: 1,
        showQuickJumper: false,
        showSizeChanger: true,
        onShowSizeChange: (current, pagesize) => {
          this.showSizeChange(current, pagesize);// 改变后调onchange
        },
        onChange: (current, pagesize) => {
          this.pagination.current = current;
          this.getList();
        },
        pageSizeOptions: ['10', '20', '50'],
      },
      allSelected: false,
      currentOperate: '',
      rowData:{
      },
    };
  },
  watch: {
    params:{
      handler(newV,oldV){
        (!_.isEqual(newV,oldV))&&this.getList();
      },
      immediate:true,
      deep:true,
    }
  },
  computed: {},
  mounted(){
  },
  methods: {
    moment,
    showSizeChange(current, pageSize) {
      this.pagination = { ...this.pagination, pageSize };
      this.pagination.onChange(current, pageSize);
    },
    getList() {
      if(this.isUpperPage) return;
      this.loading = true;
      let params = {
        "pageIndex": 0,
        "pageSize": 10,
        "params": this.params,
      }
      try {
        // eBase.send({ url:this.queryUrl,params,},'post').then((res) => {
        //   this.loading = false;
        //   if(res.data.code==0){
        //     this.data = res.data.rows;
        //   }
        // },(err)=>{
        //   this.loading = false;
        //   console.log(err);
        // });
        let table_body = document.querySelector('.ant-table-tbody');
        table_body.innerHTML = '';
        const { rows, total } = tableData;
        console.log(tableData)
        this.data = rows;
        this.loading = false;
        this.pagination.total = +total;
      } catch (e) {
        console.error(e.message);
        this.loading = false;
      }
    },
    enterpriseName(record) {
      this.$router.push({path:'/dashboard/monitorAnalysis/enterpriseName'});
    },
    producePollution(){
      this.$router.push({path:'/dashboard/monitorAnalysis/producePollution'});
    },
  },
  created() {
    this.getList();
  },
  mounted() {
  },
  filters:{
    formatterTime(timeStr){
      return timeStr?moment(timeStr,'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DD HH:mm:ss'):'';
    }
  }
};
</script>
<style lang="less" scoped>
.wrapper {
}
</style>



// WEBPACK FOOTER //
// src/views/unusualEnterpriseAmount/components/PaginationTable.vue